import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from './Roundel.module.scss'

export const WhatsappRoundelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  className,
  ...rest
}) => {
  return (
    <Icon
      className={classnames(styles.whatsapp, className)}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M16,6.99999814 C20.9705627,6.99999814 25,11.0294373 25,15.9999981 C24.9977697,19.1733401 23.3245259,22.1109817 20.5961952,23.7315691 C17.8678644,25.3521565 14.4877184,25.4161525 11.7,23.9 L7,24.9999981 L8.2,20.4999981 C6.59178841,17.7144973 6.5923381,14.2824871 8.20144191,11.4974998 C9.81054571,8.71251242 12.7835788,6.99793705 16,6.99999814 L16,6.99999814 Z M13,11.8 L12.8,11.8 C12.7,11.8 12.4,11.8 12.2,12.1 C12,12.3 11.4,12.9 11.4,14 C11.4,15.1 12.2,16.2 12.4,16.3 C12.4,16.5 13.9,18.8 16.2,19.7 C18.1,20.5 18.5,20.3 18.9,20.3 C19.3,20.3 20.2,19.7 20.4,19.2 C20.6,18.7 20.6,18.2 20.5,18.2 C20.5,18 20.3,18 20.1,17.9 L18.6,17.1 C18.4,17.1 18.2,17.1 18.1,17.3 L17.4,18.1 C17.2,18.3 17.1,18.3 16.9,18.1 C16.6,18.1 15.9,17.8 15.1,17.1 C14.5878699,16.6358346 14.1495,16.0963024 13.8,15.5 C13.7,15.3 13.8,15.2 13.9,15.1 L14.3,14.7 L14.5,14.3 L14.5,13.9 L13.8,12.2 C13.6,11.9 13.4,11.8 13.3,11.8 L12.8,11.8 L13,11.8 Z"
        data-testid="roundel-icon-whatsapp"
        fill="#ffffff"
        className={styles.white}
        fillRule="nonzero"
      />
    </Icon>
  )
}
